import { v4 as uuidv4 } from 'uuid';

/**
 * Generates UUID.
 * @returns a string with unique identifier.
 */
export default function uuid(): string {
  return uuidv4();
}